<template>
  <div>
    <!-- 视图切换 -->
    <div>
      <el-button-group>
        <el-button
          :type="!showCalendar ? 'primary' : 'default'"
          @click="toggleView(false)"
          size="small"
          :loading="dataListLoading && !showCalendar"
        >
          <i class="el-icon-menu"></i> {{ $t('appointmentManagement.listView') }}
        </el-button>
        <el-button
          :type="showCalendar ? 'primary' : 'default'"
          @click="toggleView(true)"
          size="small"
          :loading="dataListLoading && showCalendar"
        >
          <i class="el-icon-date"></i> {{ $t('appointmentManagement.calendarView') }}
        </el-button>
      </el-button-group>
      <div v-if="showCalendar && !isCachedComplete">
        {{ $t('appointmentManagement.loadingAllData', { count: cachedAllData.length }) }}
      </div>
    </div>

    <!-- 列表视图 -->
    <div v-if="!showCalendar">
      <div v-if="showFlag">
        <el-form :inline="true" :model="searchForm">
          <el-row :gutter="20" class="search-form">
            <el-form-item :label="$t('coachManagement.coachNumber')">
              <el-input
                v-model="searchForm.jiaolianbianhao"
                :placeholder="$t('coachManagement.coachNumber')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('coachManagement.coachName')">
              <el-input
                v-model="searchForm.jiaolianxingming"
                :placeholder="$t('coachManagement.coachName')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('appointment.startDate')">
              <el-date-picker
                v-model="searchForm.startDate"
                type="date"
                :placeholder="$t('appointment.selectStartDate')"
                value-format="yyyy-MM-dd"
                clearable
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('appointment.endDate')">
              <el-date-picker
                v-model="searchForm.endDate"
                type="date"
                :placeholder="$t('appointment.selectEndDate')"
                value-format="yyyy-MM-dd"
                clearable
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="search()">{{ $t('common.search') }}</el-button>
              <el-button @click="resetSearch()">{{ $t('common.reset') }}</el-button>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item>
              <el-button
                v-if="isAuth('jiaolianyuyue','新增')"
                type="success"
                @click="addOrUpdateHandler()"
              >{{ $t('common.add') }}</el-button>
              <el-button
                v-if="isAuth('jiaolianyuyue','删除')"
                :disabled="dataListSelections.length <= 0"
                type="danger"
                @click="deleteHandler()"
              >{{ $t('common.delete') }}</el-button>
            </el-form-item>
          </el-row>
        </el-form>

        <el-table
          :data="sortedDataList"
          v-loading="dataListLoading"
          @selection-change="selectionChangeHandler"
          :row-class-name="tableRowClassName"
        >
          <el-table-column
            v-if="contents.tableSelection"
            type="selection"
            width="50"
          ></el-table-column>
          <el-table-column
            v-if="contents.tableIndex"
            type="index"
            :label="$t('common.index')"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="id"
            :label="$t('appointmentManagement.appointmentId')"
          ></el-table-column>
          <el-table-column
            prop="jiaolianbianhao"
            :label="$t('coachManagement.coachNumber')"
          ></el-table-column>
          <el-table-column
            prop="jiaolianxingming"
            :label="$t('coachManagement.coachName')"
          ></el-table-column>
          <el-table-column
            prop="startTime"
            :label="$t('appointmentManagement.appointmentTime')"
          ></el-table-column>
          <el-table-column
            prop="endTime"
            :label="$t('appointment.endTime')"
          ></el-table-column>
          <el-table-column
            prop="duration"
            :label="$t('appointment.duration')"
          ></el-table-column>
          <el-table-column
            prop="yuyueshuoming"
            :label="$t('appointment.description')"
          ></el-table-column>
          <el-table-column
            prop="zhanghao"
            :label="$t('appointment.account')"
          ></el-table-column>
          <el-table-column
            prop="xingming"
            :label="$t('appointment.name')"
          ></el-table-column>
          <el-table-column
            prop="shouji"
            :label="$t('appointment.phone')"
          ></el-table-column>
          <el-table-column
            prop="shhf"
            :label="$t('appointment.auditReply')"
          ></el-table-column>
          <el-table-column prop="sfsh" :label="$t('appointment.auditStatus')">
            <template slot-scope="scope">
              <span>{{ scope.row.sfsh === '是' ? $t('appointment.passed') : $t('appointment.notPassed') }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isAuth('jiaolianyuyue','审核')"
            :label="$t('appointment.audit')"
          >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="shDialog(scope.row)">{{ $t('appointment.audit') }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="paymentStatus" header-align="center" align="center" :label="$t('appointment.paymentStatus')">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.paymentStatus === 0" type="warning">{{ $t('appointment.pendingPayment') }}</el-tag>
              <el-tag v-else-if="scope.row.paymentStatus === 1" type="success">{{ $t('appointment.paid') }}</el-tag>
              <el-tag v-else-if="scope.row.paymentStatus === 2" type="info">{{ $t('appointment.cancelled') }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="paymentMethod" header-align="center" align="center" :label="$t('appointment.paymentMethod')">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.paymentMethod === 1" type="primary">{{ $t('appointment.onlinePayment') }}</el-tag>
              <el-tag v-else-if="scope.row.paymentMethod === 2" type="warning">{{ $t('appointment.offlinePayment') }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')" width="300">
            <template slot-scope="scope">
              <el-button
                v-if="isAuth('jiaolianyuyue','查看')"
                type="success"
                size="mini"
                @click="addOrUpdateHandler(scope.row.id, 'info')"
              >{{ $t('common.detail') }}</el-button>
              <el-button
                v-if="isAuth('jiaolianyuyue','修改')"
                type="primary"
                size="mini"
                @click="addOrUpdateHandler(scope.row.id)"
              >{{ $t('common.edit') }}</el-button>
              <el-button
                v-if="isAuth('jiaolianyuyue','删除')"
                type="danger"
                size="mini"
                @click="deleteHandler(scope.row.id)"
              >{{ $t('common.delete') }}</el-button>
              <el-button v-if="scope.row.paymentStatus === 0 && scope.row.paymentMethod === 2" type="text" size="small" @click="handleOfflinePayment(scope.row)">{{ $t('appointment.handlePayment') }}</el-button>
              <el-button v-if="scope.row.paymentStatus === 0" type="text" size="small" @click="handleCancelUnpaid(scope.row)">{{ $t('appointment.cancelAppointment') }}</el-button>
              <el-button 
                type="warning" 
                size="mini" 
                @click="goToUpgrade(scope.row.id)"
                v-if="scope.row.sfsh === '是' && scope.row.paymentStatus === 1"
              >{{ $t('appointment.upgrade') }}</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          :current-page="pageIndex"
          :page-sizes="[10,20,50,100]"
          :page-size="Number(contents.pageEachNum)"
          :total="totalPage"
          :small="contents.pageStyle"
          :background="contents.pageBtnBG"
          :style="{
            textAlign:
              contents.pagePosition == 1
                ? 'left'
                : (contents.pagePosition == 2 ? 'center' : 'right')
          }"
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
        ></el-pagination>
      </div>
    </div>

    <!-- 日历视图 -->
    <div v-else>
      <coach-calendar
        :key="'calendar-' + cachedAllData.length"
        :events="cachedAllData"
        :loading="!isCachedComplete"
      />
      <div v-if="!isCachedComplete">
        <el-progress
          :percentage="Math.min((cachedAllData.length / totalPage) * 100, 100)"
          :stroke-width="18"
          :text-inside="true"
          status="success"
        />
        <div>正在加载全部数据...（已加载 {{ cachedAllData.length }} 条）</div>
      </div>
    </div>

    <!-- 新增/修改弹窗 -->
    <add-or-update
      v-if="addOrUpdateFlag"
      :parent="this"
      ref="addOrUpdate"
    ></add-or-update>

    <!-- 审核对话框 -->
    <el-dialog title="审核" :visible.sync="sfshVisiable" width="50%">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="审核状态">
          <el-select v-model="shForm.sfsh" placeholder="审核状态">
            <el-option label="通过" value="是"></el-option>
            <el-option label="不通过" value="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容">
          <el-input type="textarea" :rows="8" v-model="shForm.shhf"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shDialog">取消</el-button>
        <el-button type="primary" @click="shHandler">确定</el-button>
      </span>
    </el-dialog>

    <!-- 处理付款弹窗 -->
    <el-dialog title="处理到店付款" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" width="500px" class="el-dialog">
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="100px">
        <el-form-item label="付款处理人" prop="paymentHandler">
          <el-input v-model="dataForm.paymentHandler" placeholder="请输入付款处理人"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="paymentRemark">
          <el-input v-model="dataForm.paymentRemark" type="textarea" placeholder="请输入备注信息"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import AddOrUpdate from "./add-or-update";
import CoachCalendar from '@/components/common/CoachCalendar'

export default {
  data() {
    return {
      showCalendar: false,
      cachedAllData: [],    // 新增：缓存所有分页数据
      isCachedComplete: false, // 新增：是否完成全部数据缓存
      currentSearchParams: null, // 新增：当前搜索参数快照
      searchForm: {
        key: "",
        jiaolianbianhao: "",
        jiaolianxingming: "",
        startDate: "",
        endDate: ""
      },
      form:{},
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      sfshVisiable: false,
      shForm: {},
      chartVisiable: false,
      addOrUpdateFlag:false,
      contents:{"searchBtnFontColor":"rgba(0, 0, 0, 1)","pagePosition":"2","inputFontSize":"14px","inputBorderRadius":"20px","tableBtnDelFontColor":"rgba(0, 0, 0, 1)","tableBtnIconPosition":"1","searchBtnHeight":"42px","tableBgColor":"rgba(255, 255, 255, 1)","inputIconColor":"rgba(0, 0, 0, 1)","searchBtnBorderRadius":"20px","tableStripe":false,"btnAdAllWarnFontColor":"rgba(0, 0, 0, 1)","tableBtnDelBgColor":"rgba(56, 182, 230, 1)","searchBtnIcon":"1","tableSize":"medium","searchBtnBorderStyle":"double","text":{"padding":"0","boxShadow":"0 0 0px rgba(0,0,0,.1)","margin":"0 auto","borderColor":"rgba(0,0,0,.3)","backgroundColor":"rgba(247, 247, 247, 0)","color":"rgba(0, 0, 0, 1)","borderRadius":"0","borderWidth":"0","width":"650px","lineHeight":"50px","fontSize":"26px","borderStyle":"solid"},"tableSelection":true,"searchBtnBorderWidth":"5px 000","tableContentFontSize":"14px","searchBtnBgColor":"#fff","inputTitleSize":"15px","btnAdAllBorderColor":"rgba(56, 182, 230, 1)","pageJumper":true,"btnAdAllIconPosition":"1","searchBoxPosition":"2","tableBtnDetailFontColor":"rgba(0, 0, 0, 1)","tableBtnHeight":"40px","pagePager":true,"searchBtnBorderColor":"rgba(56, 182, 230, 1)","tableHeaderFontColor":"rgba(0, 1, 4, 1)","inputTitle":"1","tableBtnBorderRadius":"5px","btnAdAllFont":"1","btnAdAllDelFontColor":"rgba(0, 0, 0, 1)","tableBtnIcon":"1","btnAdAllHeight":"46px","btnAdAllWarnBgColor":"rgba(255, 255, 255, 1)","btnAdAllBorderWidth":"5px 000","tableStripeFontColor":"rgba(0, 0, 0, 1)","tableBtnBorderStyle":"double","inputHeight":"42px","btnAdAllBorderRadius":"20px","btnAdAllDelBgColor":"rgba(255, 255, 255, 1)","pagePrevNext":true,"btnAdAllAddBgColor":"rgba(255, 255, 255, 1)","searchBtnFont":"1","tableIndex":true,"btnAdAllIcon":"0","tableSortable":false,"pageSizes":true,"tableFit":true,"pageBtnBG":true,"searchBtnFontSize":"15px","tableBtnEditBgColor":"rgba(56, 182, 230, 1)","box":{"padding":"10px 20px","boxShadow":"0 0 6px rgba(0,0,0,0)","flag":1,"backgroundImage":"http://codegen.caihongy.cn/20211124/229bbb98f09a41bc83995f14c422a0a1.jpg","background":"#fff"},"inputBorderWidth":"5px 000","inputFontPosition":"1","inputFontColor":"rgba(0, 0, 0, 1)","pageEachNum":10,"tableHeaderBgColor":"rgba(119, 197, 227, 1)","inputTitleColor":"rgba(0, 0, 0, 1)","btnAdAllBoxPosition":"1","tableBtnDetailBgColor":"rgba(56, 182, 230, 1)","inputIcon":"1","searchBtnIconPosition":"2","btnAdAllFontSize":"14px","inputBorderStyle":"double","tableHoverFontColor":"#333","inputBgColor":"rgba(255, 255, 255, 1)","pageStyle":false,"pageTotal":true,"btnAdAllAddFontColor":"rgba(0, 0, 0, 1)","tableBtnFont":"1","tableContentFontColor":"rgba(0, 0, 0, 1)","inputBorderColor":"rgba(56, 182, 230, 1)","tableShowHeader":true,"tableHoverBgColor":"rgba(119, 197, 227, 0.8)","tableBtnFontSize":"14px","tableBtnBorderColor":"rgba(255, 255, 255, 1)","inputIconPosition":"2","tableBorder":true,"btnAdAllBorderStyle":"double","tableBtnBorderWidth":"5px","tableStripeBgColor":"rgba(119, 197, 227, 0.8)","tableBtnEditFontColor":"rgba(0, 0, 0, 1)","tableAlign":"center"},
      layouts: '',
      dataForm: {
        id: 0,
        paymentStatus: 0,
        paymentMethod: 1,
        paymentTime: '',
        paymentHandler: '',
        paymentRemark: ''
      },
      dialogVisible: false,
      dataRule: {
        paymentHandler: [{ required: true, message: '请输入付款处理人', trigger: 'blur' }],
        paymentRemark: [{ required: true, message: '请输入备注信息', trigger: 'blur' }]
      },
      currentTime: new Date(),
    };
  },
  computed: {
    // 排序后的数据列表，正在进行的预约置顶
    sortedDataList() {
      if (!this.dataList || this.dataList.length === 0) return [];
      
      // 刷新当前时间，确保计算准确
      this.currentTime = new Date();
      
      return [...this.dataList].sort((a, b) => {
        // 检查是否是正在进行的预约
        const aInProgress = this.isAppointmentInProgress(a);
        const bInProgress = this.isAppointmentInProgress(b);
        
        // 正在进行的排在前面
        if (aInProgress && !bInProgress) return -1;
        if (!aInProgress && bInProgress) return 1;
        
        // 如果状态相同，按照预约时间排序
        return new Date(b.startTime) - new Date(a.startTime);
      });
    }
  },
  watch: {
    // 监听搜索条件变化
    searchForm: {
      handler(newVal) {
        this.resetCache()
      },
      deep: true
    }
  },
  created() {
    this.init();
    this.getDataList();
    this.contentStyleChange()
  },
  mounted() {

  },
  filters: {
    htmlfilter: function (val) {
      return val.replace(/<[^>]*>/g).replace(/undefined/g,'');
    }
  },
  components: {
    AddOrUpdate,
    CoachCalendar
  },
  methods: {
    // goToSetAvailability() {
  //   this.$router.push('/setAvailability');
  // },
  // checkAvailability() {
  //   this.$router.push('/availability');
  // },
  resetCache() {
      this.cachedAllData = []
      this.isCachedComplete = false
      this.currentSearchParams = null
    },
    contentStyleChange() {
      this.contentSearchStyleChange()
      this.contentBtnAdAllStyleChange()
      this.contentSearchBtnStyleChange()
      this.contentTableBtnStyleChange()
      this.contentPageStyleChange()
    },
    contentSearchStyleChange() {
      this.$nextTick(()=>{
        document.querySelectorAll('.form-content .slt .el-input__inner').forEach(el=>{
          let textAlign = 'left'
          if(this.contents.inputFontPosition == 2) textAlign = 'center'
          if(this.contents.inputFontPosition == 3) textAlign = 'right'
          el.style.textAlign = textAlign
          el.style.height = this.contents.inputHeight
          el.style.lineHeight = this.contents.inputHeight
          el.style.color = this.contents.inputFontColor
          el.style.fontSize = this.contents.inputFontSize
          el.style.borderWidth = this.contents.inputBorderWidth
          el.style.borderStyle = this.contents.inputBorderStyle
          el.style.borderColor = this.contents.inputBorderColor
          el.style.borderRadius = this.contents.inputBorderRadius
          el.style.backgroundColor = this.contents.inputBgColor
        })
        if(this.contents.inputTitle) {
          document.querySelectorAll('.form-content .slt .el-form-item__label').forEach(el=>{
            el.style.color = this.contents.inputTitleColor
            el.style.fontSize = this.contents.inputTitleSize
            el.style.lineHeight = this.contents.inputHeight
          })
        }
        setTimeout(()=>{
          document.querySelectorAll('.form-content .slt .el-input__prefix').forEach(el=>{
            el.style.color = this.contents.inputIconColor
            el.style.lineHeight = this.contents.inputHeight
          })
          document.querySelectorAll('.form-content .slt .el-input__suffix').forEach(el=>{
            el.style.color = this.contents.inputIconColor
            el.style.lineHeight = this.contents.inputHeight
          })
          document.querySelectorAll('.form-content .slt .el-input__icon').forEach(el=>{
            el.style.lineHeight = this.contents.inputHeight
          })
        },10)

      })
    },
    // 搜索按钮
    contentSearchBtnStyleChange() {
      this.$nextTick(()=>{
        document.querySelectorAll('.form-content .slt .el-button--success').forEach(el=>{
          el.style.height = this.contents.searchBtnHeight
          el.style.color = this.contents.searchBtnFontColor
          el.style.fontSize = this.contents.searchBtnFontSize
          el.style.borderWidth = this.contents.searchBtnBorderWidth
          el.style.borderStyle = this.contents.searchBtnBorderStyle
          el.style.borderColor = this.contents.searchBtnBorderColor
          el.style.borderRadius = this.contents.searchBtnBorderRadius
          el.style.backgroundColor = this.contents.searchBtnBgColor
        })
      })
    },
    // 新增、批量删除
    contentBtnAdAllStyleChange() {
      this.$nextTick(()=>{
        document.querySelectorAll('.form-content .ad .el-button--success').forEach(el=>{
          el.style.height = this.contents.btnAdAllHeight
          el.style.color = this.contents.btnAdAllAddFontColor
          el.style.fontSize = this.contents.btnAdAllFontSize
          el.style.borderWidth = this.contents.btnAdAllBorderWidth
          el.style.borderStyle = this.contents.btnAdAllBorderStyle
          el.style.borderColor = this.contents.btnAdAllBorderColor
          el.style.borderRadius = this.contents.btnAdAllBorderRadius
          el.style.backgroundColor = this.contents.btnAdAllAddBgColor
        })
        document.querySelectorAll('.form-content .ad .el-button--danger').forEach(el=>{
          el.style.height = this.contents.btnAdAllHeight
          el.style.color = this.contents.btnAdAllDelFontColor
          el.style.fontSize = this.contents.btnAdAllFontSize
          el.style.borderWidth = this.contents.btnAdAllBorderWidth
          el.style.borderStyle = this.contents.btnAdAllBorderStyle
          el.style.borderColor = this.contents.btnAdAllBorderColor
          el.style.borderRadius = this.contents.btnAdAllBorderRadius
          el.style.backgroundColor = this.contents.btnAdAllDelBgColor
        })
        document.querySelectorAll('.form-content .ad .el-button--warning').forEach(el=>{
          el.style.height = this.contents.btnAdAllHeight
          el.style.color = this.contents.btnAdAllWarnFontColor
          el.style.fontSize = this.contents.btnAdAllFontSize
          el.style.borderWidth = this.contents.btnAdAllBorderWidth
          el.style.borderStyle = this.contents.btnAdAllBorderStyle
          el.style.borderColor = this.contents.btnAdAllBorderColor
          el.style.borderRadius = this.contents.btnAdAllBorderRadius
          el.style.backgroundColor = this.contents.btnAdAllWarnBgColor
        })
      })
    },
    headerRowStyle({ row, rowIndex}){
      return {color: this.contents.tableHeaderFontColor}
    },
    headerCellStyle({ row, rowIndex}){
      return {backgroundColor: this.contents.tableHeaderBgColor}
    },
    // 表格按钮
    contentTableBtnStyleChange(){
    },
    // 分页
    contentPageStyleChange(){
      let arr = []

      if(this.contents.pageTotal) arr.push('total')
      if(this.contents.pageSizes) arr.push('sizes')
      if(this.contents.pagePrevNext){
        arr.push('prev')
        if(this.contents.pagePager) arr.push('pager')
        arr.push('next')
      }
      if(this.contents.pageJumper) arr.push('jumper')
      this.layouts = arr.join()
      this.contents.pageEachNum = 10
    },

    init () {
    },

    async getDataList() {
      this.dataListLoading = true;
      
      // 生成当前查询参数指纹
      const paramsFingerprint = JSON.stringify({
        search: this.searchForm,
        page: this.pageIndex,
        pageSize: this.pageSize
      })

      try {
        const params = {
          page: this.pageIndex,
          limit: this.pageSize,
          sort: 'start_time',
          order: 'desc',
          jiaolianbianhao: this.searchForm.jiaolianbianhao ? `%${this.searchForm.jiaolianbianhao}%` : undefined,
          jiaolianxingming: this.searchForm.jiaolianxingming ? `%${this.searchForm.jiaolianxingming}%` : undefined,
          startDate: this.searchForm.startDate || undefined,
          endDate: this.searchForm.endDate || undefined
        }

        const { data } = await this.$http({
          url: "jiaolianyuyue/page",
          method: "get",
          params
        })

        if (data && data.code === 0) {
          console.log("jialianyuyue",data);
          
          if (this.showCalendar) {
            // 日历视图模式下的缓存处理
            this.cachedAllData = [...this.cachedAllData, ...data.data.list]
            this.currentSearchParams = paramsFingerprint
            
            // 计算总页数并判断是否需要继续加载
            const totalPages = Math.ceil(data.data.total / this.pageSize)
            if (this.pageIndex < totalPages) {
              this.pageIndex++
              await this.getDataList() // 递归获取下一页
            } else {
              this.isCachedComplete = true
              this.dataList = this.cachedAllData // 更新列表显示最后一批数据
              this.totalPage = data.data.total
            }
          } else {
            // 普通列表模式
            this.dataList = data.data.list
            this.totalPage = data.data.total
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.dataListLoading = false
      }
    },

    // 修改后的切换视图方法
    // 修改后的切换视图方法
    async toggleView(isCalendar) {
      if (this.showCalendar === isCalendar) return
      
      const originalPage = {
        index: this.pageIndex,
        size: this.pageSize
      }
      
      this.showCalendar = isCalendar
      
      if (isCalendar) {
        // 进入日历视图模式
        this.resetCache()
        this.pageIndex = 1
        this.pageSize = 100 // 增大每页数量减少请求次数
        await this.getDataList()
        
        // 恢复原始分页设置
        this.pageIndex = originalPage.index
        this.pageSize = originalPage.size
      } else {
        // 返回列表视图时刷新数据
        this.pageIndex = 1
        this.getDataList()
      }
    },

    // 修改后的搜索方法
    search() {
      this.resetCache()
      this.pageIndex = 1
      this.getDataList()
    },
    // 重置搜索条件
    resetSearch() {
      this.searchForm = {
        key: "",
        jiaolianbianhao: "",
        jiaolianxingming: "",
        startDate: "",
        endDate: ""
      }
      this.resetCache()
      this.pageIndex = 1
      this.getDataList()
    },

    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 添加/修改
    addOrUpdateHandler(id,type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.crossAddOrUpdateFlag = false;
      if(type!='info'){
        type = 'else';
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id,type);
      });
    },
    // 查看评论
    // 审核窗口
    shDialog(row){
      this.sfshVisiable = !this.sfshVisiable;
      if(row){
        this.shForm = {
          jiaolianbianhao: row.jiaolianbianhao,
          jiaolianxingming: row.jiaolianxingming,
          yuyueshijian: row.yuyueshijian,
          yuyueshuoming: row.yuyueshuoming,
          zhanghao: row.zhanghao,
          xingming: row.xingming,
          shouji: row.shouji,
          sfsh: row.sfsh,
          shhf: row.shhf,
          id: row.id
        }
      }
    },
    // 审核
    shHandler(){
      this.$confirm(`确定操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "jiaolianyuyue/update",
          method: "post",
          data: this.shForm
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.getDataList();
                this.shDialog()
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    // 下载
    download(file){
      window.open(`${file}`)
    },
    // 删除
    deleteHandler(id) {
      var ids = id
        ? [Number(id)]
        : this.dataListSelections.map(item => {
            return Number(item.id);
          });
      this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "jiaolianyuyue/delete",
          method: "post",
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    // 处理到店付款
    handleOfflinePayment(row) {
      this.dataForm = {
        id: row.id,
        paymentStatus: 1,
        paymentMethod: 2,
        paymentTime: new Date(),
        paymentHandler: '',
        paymentRemark: ''
      }
      this.dialogVisible = true
    },
    
    // 提交付款处理
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: '/jiaolianyuyue/handleOfflinePayment',
            method: 'post',
            data: this.dataForm
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.dialogVisible = false
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    
    // 取消未支付预约
    handleCancelUnpaid(row) {
      this.$confirm(`确定要取消预约编号为 ${row.id} 的预约吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/jiaolianyuyue/cancelUnpaidAppointment',
          method: 'post',
          params: {
            'appointmentId': row.id
          }
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    
    // 添加跳转到升级页面的方法
    goToUpgrade(id) {
      this.$router.push({
        path: '/upgrade-add',
        query: { appointmentId: id }
      });
    },
    
    // 判断预约是否正在进行中
    isAppointmentInProgress(appointment) {
      if (!appointment || !appointment.startTime) return false;
      
      const appointmentTime = new Date(appointment.startTime);
      const currentTime = this.currentTime;
      
      // 假设每次预约持续1小时，可根据实际需求调整
      // const appointmentEndTime = new Date(appointmentTime.getTime() + 60 * 60 * 1000);
      const appointmentEndTime = new Date(appointment.endTime)
      
      return currentTime >= appointmentTime && currentTime <= appointmentEndTime;
    },
    
    // 设置表格行的类名
    tableRowClassName({row}) {
      return this.isAppointmentInProgress(row) ? 'in-progress-row' : '';
    },
  }

};
</script>
<style>
  .slt {
    margin: 0 !important;
    display: flex;
  }

  .ad {
    margin: 0 !important;
    display: flex;
  }

  .pages {
    & /deep/ el-pagination__sizes{
      & /deep/ el-input__inner {
        height: 22px;
        line-height: 22px;
      }
    }
  }
  

  .el-button+.el-button {
    margin:0;
  } 

  .tables {
	& /deep/ .el-button--success {
		height: 40px;
		color: rgba(0, 0, 0, 1);
		font-size: 14px;
		border-width: 5px;
		border-style: double;
		border-color: rgba(255, 255, 255, 1);
		border-radius: 5px;
		background-color: rgba(56, 182, 230, 1);
	}
	
	& /deep/ .el-button--primary {
		height: 40px;
		color: rgba(0, 0, 0, 1);
		font-size: 14px;
		border-width: 5px;
		border-style: double;
		border-color: rgba(255, 255, 255, 1);
		border-radius: 5px;
		background-color: rgba(56, 182, 230, 1);
	}
	
	& /deep/ .el-button--danger {
		height: 40px;
		color: rgba(0, 0, 0, 1);
		font-size: 14px;
		border-width: 5px;
		border-style: double;
		border-color: rgba(255, 255, 255, 1);
		border-radius: 5px;
		background-color: rgba(56, 182, 230, 1);
	}

    & /deep/ .el-button {
      margin: 4px;
    }
  }
	.form-content {
		background: transparent;
	}
	.table-content {
		background: transparent;
	}
	
	.tables /deep/ .el-table__body tr {
				background-color: rgba(255, 255, 255, 1) !important;
				color: rgba(0, 0, 0, 1) !important;
	 }
	.tables /deep/ .el-table__body tr.el-table__row--striped td {
	    background: transparent;
	}
	.tables /deep/ .el-table__body tr.el-table__row--striped {
		background-color: rgba(119, 197, 227, 0.8) !important;
		color: rgba(0, 0, 0, 1) !important;
	}
	
	 .tables /deep/ .el-table__body tr:hover>td {
	   	   background-color: rgba(119, 197, 227, 0.8) !important;
	   	   	   color: #333 !important;
	   	 }
	 
 .view-toolbar {
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.view-toolbar .el-button-group {
  margin-left: auto;
}

.el-button-group {
  margin-bottom: 20px;
}


.list-view {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,.1);
}

.loading-mask {
  position: absolute;
  z-index: 999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.9);
  padding: 20px 40px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.loading-text {
  margin-top: 10px;
  text-align: center;
  color: #666;
}

.calendar-view {
  position: relative;
  min-height: 600px;
}
.calendar-toolbar{
  display: none;
}

/* 正在进行中的预约行样式 */
.in-progress-row {
  background-color: #fdf6ec !important;
  font-weight: bold;
  border-left: 4px solid #e6a23c;
}

/* 确保高亮状态在鼠标悬停时保持 */
.el-table__body tr.in-progress-row:hover > td {
  background-color: #faecd8 !important;
}

.search-form{
  margin-left:0 !important;
}

.slt {
  margin: 0 !important;
  display: flex;
  }

  .ad {
    margin: 0 !important;
    display: flex;
  }

  .pages {
    & /deep/ el-pagination__sizes{
      & /deep/ el-input__inner {
        height: 22px;
        line-height: 22px;
      }
    }
  }
  

  .el-button+.el-button {
    margin:0;
  } 

  .tables {
	& /deep/ .el-button--success {
		height: 40px;
		color: rgba(0, 0, 0, 1);
		font-size: 14px;
		border-width: 5px;
		border-style: double;
		border-color: rgba(255, 255, 255, 1);
		border-radius: 5px;
		background-color: rgba(56, 182, 230, 1);
	}
	
	& /deep/ .el-button--primary {
		height: 40px;
		color: rgba(0, 0, 0, 1);
		font-size: 14px;
		border-width: 5px;
		border-style: double;
		border-color: rgba(255, 255, 255, 1);
		border-radius: 5px;
		background-color: rgba(56, 182, 230, 1);
	}
	
	& /deep/ .el-button--danger {
		height: 40px;
		color: rgba(0, 0, 0, 1);
		font-size: 14px;
		border-width: 5px;
		border-style: double;
		border-color: rgba(255, 255, 255, 1);
		border-radius: 5px;
		background-color: rgba(56, 182, 230, 1);
	}

    & /deep/ .el-button {
      margin: 4px;
    }
  }
	.form-content {
		background: transparent;
	}
	.table-content {
		background: transparent;
	}
	
	.tables /deep/ .el-table__body tr {
				background-color: rgba(255, 255, 255, 1) !important;
				color: rgba(0, 0, 0, 1) !important;
	 }
	.tables /deep/ .el-table__body tr.el-table__row--striped td {
	    background: transparent;
	}
	.tables /deep/ .el-table__body tr.el-table__row--striped {
		background-color: rgba(119, 197, 227, 0.8) !important;
		color: rgba(0, 0, 0, 1) !important;
	}
	
	 .tables /deep/ .el-table__body tr:hover>td {
	   	   background-color: rgba(119, 197, 227, 0.8) !important;
	   	   	   color: #333 !important;
	   	 }
	 
 .view-toolbar {
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.view-toolbar .el-button-group {
  margin-left: auto;
}

.list-view {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,.1);
}

.loading-mask {
  position: absolute;
  z-index: 999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.9);
  padding: 20px 40px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.loading-text {
  margin-top: 10px;
  text-align: center;
  color: #666;
}

.calendar-view {
  position: relative;
  min-height: 600px;
}
.calendar-toolbar{
  display: none;
}
</style>